export default __webpack_public_path__ + "static/media/photo--lg--chris-6.989dc9c2.jpg";